import React, { useState } from 'react'
import { GenericModal } from '../../../../atomic/organisms/GenericModal';
import { 
  Grid,
  Table,
  TableBody,
  TableCell, 
  TableHead, 
  TablePagination, 
  TableRow 
} from '@material-ui/core';
import { diasSemana } from '../../../../../utils/constants';

const optionsFecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const HorariosCentroEspecialidad = ({openModalHorarios, 
  setOpenModalHorarios, horarios}) => {
    
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Grid container spacing={1}>
      {openModalHorarios &&
        <GenericModal 
          open={openModalHorarios}
          title={'Horarios Centro Especialidad'}
          closeModal={() => setOpenModalHorarios(false)}
          children={
            <>
              <Grid item xs={12}>
                <Table size={"small"}>
                  <TableHead
                    style={{ display: "table", width: "98.5%", tableLayout: "fixed" }}
                  >
                    <TableRow>
                      <TableCell style={{ width: "41%" }}>Centro Médico</TableCell>
                      <TableCell style={{ width: "10%" }}>Dia</TableCell>
                      <TableCell style={{ width: "15%" }} align="center">Horario</TableCell>
                      <TableCell style={{ width: "17%" }} align="center">Fecha Desde</TableCell>
                      <TableCell style={{ width: "17%" }} align="center">Fecha Hasta</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    style={{ display: "table", width: "98.5%", maxHeight: "29rem", overflowY: "auto" }}
                  >
                    {horarios.length > 0 && (
                      horarios.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((item, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{item.centroMedico}</TableCell>
                            <TableCell>{diasSemana.find(s => s.value===item.dia).display}</TableCell>
                            <TableCell>
                              {`${item.horarioDesde} a ${item.horarioHasta}`}
                            </TableCell>
                            <TableCell>
                              {new Date(item.fechaInicio).toLocaleString(
                                "es",
                                optionsFecha
                              )}
                            </TableCell>
                            <TableCell>
                              {new Date(item.fechaFin).toLocaleString(
                                "es",
                                optionsFecha
                              )}
                            </TableCell>                          
                          </TableRow>                        
                        );
                    }))}
                    {horarios.length === 0 && (
                      <TableRow style={{ height: 50 }}>
                        <TableCell
                          colSpan={13}
                          style={{ textAlign: "-webkit-center" }}
                        >
                          {" "}
                          Sin Registros
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Grid>
              {horarios.length > 0 && (
                <Grid item xs={12}>
                  <TablePagination
                    style={{ backgroundColor: "white" }}
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={horarios.length}
                    rowsPerPage={rowsPerPage}
                    labelRowsPerPage="Registros por página"
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Grid>    
              )}
            </>
          }
        />
      }      
    </Grid>    
  )
}
